module.exports = __webpack_public_path__ + "8e1506c1679db2b972272d203f75fbad.MP3";